import Reveal from "@/components/Reveal";
import { Clock, ShieldCheck, BadgeCheck } from "lucide-react";

const stats = [
  { icon: Clock, value: "Hours → minutes", label: "Validation time per submission" },
  { icon: ShieldCheck, value: "Fewer rejections", label: "Issues caught before handover" },
  { icon: BadgeCheck, value: "One standard", label: "Consistent QA across teams" },
];

export default function Outcomes() {
  return (
    <section data-testid="outcomes-section" className="py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <Reveal className="max-w-3xl mb-14">
          <p className="text-xs font-semibold tracking-[0.2em] uppercase text-[#0033A0] font-mono">Outcomes</p>
          <h2 className="mt-4 font-heading text-3xl sm:text-4xl font-medium tracking-tight text-zinc-900 leading-tight">
            Time saved, fewer errors, and confidence before every submission.
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {stats.map((s, i) => (
            <Reveal key={s.label} delay={i * 0.08} className="rounded-2xl border border-zinc-200 bg-white p-10">
              <s.icon size={28} strokeWidth={1.5} className="text-[#0033A0]" />
              <p className="mt-6 font-heading text-2xl font-semibold tracking-tight text-zinc-900">{s.value}</p>
              <p className="mt-2 text-sm text-zinc-600">{s.label}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
